import { GetServerSideProps } from "next";
import React, { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import { Box, Typography, Button, Chip, useMediaQuery, } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import Image from "next/legacy/image";
import Breadcrumbs from "@mui/material/Breadcrumbs";
// import Link from "@mui/material/Link";


import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { BreadcrumbJsonLd, NextSeo, VideoJsonLd } from "next-seo";
import { SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/thumbs";
import ReactHtmlParser from "react-html-parser";
// import { userSelector, resetUserName, signUp } from '../../store/slices/userSlice';

import * as ApiProduct from "../../api/product";
import * as ApiStore from "../../api/store";

import axios from "axios";
import Router from "next/router";
import Cookies from "universal-cookie";

import { Config, ImgUrl, isProduction } from "../../config";
import { Data } from "../../interfaces/product/product-info";
import { checkLoginStatus } from "@/utils/authen";

import { ProductAddCart } from "../../api/cart";

import * as Campaign from "@/api/campaign";
import ProductDetail from "@/components/product/productDetail";
import dayjs from "dayjs";
import duration from 'dayjs/plugin/duration';

import ProductUtility from "@/components/cards/product-utility";
import { GetProductsInStore, GetProductsRecommend } from "../../api/store";
import { useResponsiveLimit } from "@/components/utilities/UseResponsiveLimit";
import Link from "next/link";
import Script from "next/script";
import he from "he";
import { GetCampaignComingSoon } from "@/api/campaign/campaign";
import { useResponsive } from "@/components/utilities/UseResponsive";
import { seoConfig } from "@/config/seo.config";
import { MetaTag } from "next-seo/lib/types";
import StarRatingreview from "@/components/reviewStoreProduct/starRatingreview";
import { useResponsiveLimitProduct } from "@/components/utilities/UseResponsiveLimitProduct";
dayjs.extend(duration);

export interface Root {
  success: boolean;
  dataProduct: Data;
  dataProductDetail: Data;
  dataProductSpecific: Data;
  dataWaranty: Data;
  dataReview: Data;
  dataStoreInfo: Data;
  campaign?: any;
}
interface ProductItem {
  item_id: string;
  item_name: string;
  affiliation: string | null;
  coupon: string | null;
  discount: number;
  index: number;
  item_brand: string | null;
  item_category: string | null;
  item_category2: string | null;
  item_category3: string | null;
  item_category4: string | null;
  item_category5: string | null;
  item_list_id: string;
  item_list_name: string;
  item_variant: string | null;
  location_id: string | null;
  price: number;
  quantity: number;
}

export default function StoreDetail({
  dataProduct,
  dataProductDetail,
  dataProductSpecific,
  dataWaranty,
  dataReview,
  dataStoreInfo,
  campaign,
  dataCampaigncomingsoon
}: any) {
  const router = useRouter();
  const cookies = new Cookies();
  const { isLoggedIn } = checkLoginStatus();
  // const limit = "10";

  const ProductIdReview = router.query.id as any

  const authToken = cookies.get("token");
  const getToken = authToken !== "" ? authToken : null;
  const productType = dataProduct?.products.product_type;
  // const storeId = router.query.store;

  const currentUrl = typeof window !== "undefined" ? window.location.href : "";

  const [reviewProd, setReviewProd] = useState<Number | null | String>(
    dataProduct?.products.product_score
  );
  const [dataProductSameStore, setDataProductSameStore] = useState([]);
  const [dataProductRec, setDataProductRec] = useState([]);

  const [count, setCount] = useState(1);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [activeOptionIndex, setActiveOptionIndex] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [openCart, setOpenCart] = useState(false);
  const { product_option = [] } = dataProduct?.products ?? {};
  const [priceProduct, setPriceProduct] = useState<number>(0);
  const [discountPrice, setDiscountPrice] = useState<number>(0);
  const [optionStork, setOptionStork] = useState<number>(0);

  // const [productIdOption, setProductIdOption] = useState([]);
  const [productIdOption, setProductIdOption] = useState<number | null>(null);

  const [optionChildValue, setOptionChildValue] = useState<[] | null>([]);
  const [productOption, setOption] = useState<number | null>(null);
  const campaignEnd = campaign?.campaign_end as any
  const [timeRemaining, setTimeRemaining] = useState<{ hours: number; minutes: number; seconds: number }>({ hours: 0, minutes: 0, seconds: 0 });
  const [endTime, setEndTime] = useState<any>(dayjs(campaignEnd).toDate());
  const [statusCampaignEnd, setStatusCampaignEnd] = useState(false)
  const [dataremaining, setRemaining] = useState<any>()
  const [optionChild, setOptionChild] = useState<number | null>(null);
  const [maxPrice, setMaxPrice] = useState<any>();
  const [items, setItems] = useState<ProductItem[]>([]);
  // const limitMore = useResponsive(router);
  const { limitMore } = useResponsiveLimitProduct();

  const { store: storeId } = router.query as Record<string, string>;
  const itemListRelate = { itemListId: "related_products", itemListName: "สินค้า/บริการ ที่เกี่ยวข้อง", }
  const itemListReccomment = { itemListId: "recommended_products", itemListName: "สินค้า/บริการ ที่คุณอาจจะชอบ", }

  const [dataAddcart, setdataAddcart] = useState<any>([]);
  const [nextFullPath, setNextFullPath] = useState<any>('');
  const [nextAddToCartFullPath, setNextAddToCartFullPath] = useState<any>('');
  const [priceRange, setPriceRange] = useState('');
  const [jsonLd, setJsonLd] = useState<any>(null);


  // Effects
  useEffect(() => {
    if (product_option.length !== 0) {
      setProductIdOption(product_option[0].option_id);
    }
    setPriceProduct(dataProduct?.products.product_normal_price);
    setDiscountPrice(dataProduct?.products.product_discounted_price);
    setOptionStork(dataProduct?.products.product_stock);
  }, [dataProduct]);

  useEffect(() => {
    const filteredData = product_option?.filter(
      (item: any) => item.option_id === productIdOption
    );

    if (filteredData[0]?.option_child.length !== 0) {
      setOptionChildValue(filteredData[0]?.option_child);
    } else {
      setOptionChild(0);
    }
  }, [productIdOption, product_option]);

  useEffect(() => {
    if (count > optionStork && optionStork !== 0) {
      setCount(optionStork);
    }
  }, [optionStork]);

  useEffect(() => {
    fetchDataProductSameStore(storeId, Number(limitMore), productType);
    fetchDataProductRecommend("", Number(limitMore), "")
  }, [limitMore])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const protocol = window.location.protocol;
      const host = window.location.host;
      const fullPath = encodeURIComponent(`${protocol}//${host}${router.asPath}`);
      setNextAddToCartFullPath(fullPath);
    }
  }, [router]);

  useEffect(() => {
    setPriceRange(findPriceRange(dataProduct));
    setMaxPrice(findPriceMax(dataProduct));
    // calDisplayPrice();
  }, []);

  useEffect(() => {
    setDataLayer();
    const jsonLdData = generateJsonLd();
    setJsonLd(jsonLdData);
  }, [dataProduct.products]);

  if (
    typeof dataProduct === "object" &&
    dataProduct !== null &&
    "message" in dataProduct
  ) {
    return dataProduct.products.message;
  }

  const dataCheck = {
    dataProduct,
    dataProductDetail,
    dataProductSpecific,
    dataWaranty,
    dataReview,
    dataStoreInfo,
  };

  if (dataCheck == null) {
    return "";
  }

  const formatNumber = (number: any) => {
    if (number === null || number === undefined) return '';
    return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const fetchDataProductSameStore = async (storeId: string, limitMore: number, productType: string) => {
    const response = await GetProductsInStore(storeId, limitMore, productType);
    if (response.success === true) {
      setDataProductSameStore(response?.data)
    }
  };

  const fetchDataProductRecommend = async (storeId: string, limitMore: number, productType: string) => {
    const response = await GetProductsRecommend(storeId, limitMore, productType);
    if (response.success === true) {
      setDataProductRec(response?.data)
    }
  };

  // useEffect(() => {
  //   fetchDataProductSameStore(storeId, Number(limitMore), productType);
  //   fetchDataProductRecommend("", Number(limitMore), "")
  // }, [limitMore])









  const cookie = new Cookies();
  // const [dataAddcart, setdataAddcart] = useState<any>([]);



  // const [nextFullPath, setNextFullPath] = useState<any>('');
  // const [nextAddToCartFullPath, setNextAddToCartFullPath] = useState<any>('');



  // useEffect(() => {
  //   if (typeof window !== 'undefined') {
  //     const protocol = window.location.protocol;
  //     const host = window.location.host;
  //     const fullPath = encodeURIComponent(`${protocol}//${host}${router.asPath}`);
  //     setNextAddToCartFullPath(fullPath);
  //   }
  // }, [router]);



  const handleClose = () => {
    setOpen(false);
    setOpenCart(false);
  };

  const handleCloseCart = () => {
    setOpenCart(false);
    router.reload();
  };

  const handleGoCart = () => {
    setOpenCart(false);
    router.push("/cart");
  };


  // const imageShare = dataProduct?.products?.product_image?.image_url;
  const imageShare = dataProduct?.products?.product_image?.[0]?.image_url || `${ImgUrl.pathImg}web/fb_share.png`;

  const product = dataProduct?.products;


  const mixedArray = [];

  if (product?.product_vdo) {
    mixedArray.push({ video_url: product.product_vdo });
  }

  product?.product_image?.forEach((image: any) => {
    mixedArray.push({ image_url: image.image_url });
  });


  if (
    dataProduct?.products.product_quantity === 0 &&
    dataProduct?.products.product_stock === "0"
  ) {

  } else {

  }

  // const videoRef = useRef(null);

  const findPriceMax = (dataProduct: any) => {
    let prices: number[] = [];

    if (dataProduct?.products?.product_option?.[0]?.option_child.length === 0) {
      dataProduct?.products?.product_option?.forEach((option: any) => {
        if (option.option_discount != null && option.option_price != null) {
          prices.push(option.option_price);
        }
      })
    } else {
      dataProduct?.products?.product_option?.forEach((option: any) => {
        option.option_child.forEach((child: { option_price: number | null }) => {
          if (child.option_price != null) {
            prices.push(child.option_price);
          }
        })
      })
    }

    const filteredPrices = prices.filter((price: number) => price > 0);
    if (filteredPrices.length === 0) {
      return "";
    }
    const minPrice = Math.min(...filteredPrices);
    const maxPrice = Math.max(...filteredPrices);
    return `${formatNumber(minPrice)} - ${formatNumber(maxPrice)}`;
  }

  const findPriceRange = (dataProduct: any) => {
    let prices: number[] = [];

    if (dataProduct?.products?.product_option?.[0]?.option_child.length === 0) {
      dataProduct?.products?.product_option?.forEach((option: any) => {
        if (option.option_discount !== null && option.option_price !== null) {
          prices.push(option.option_discount > 0 ? option.option_discount : option.option_price);
        }
      });
    } else {
      dataProduct?.products?.product_option?.forEach((option: any) => {
        option.option_child.forEach((child: { option_discount: number | null, option_price: number | null }) => {
          if (child.option_discount !== null && child.option_price !== null) {
            prices.push(child.option_discount > 0 ? child.option_discount : child.option_price);
          }
        });
      });
    }

    const filteredPrices = prices.filter((price: number) => price > 0);

    if (filteredPrices.length === 0) {
      return "";
    }

    const minPrice = Math.min(...filteredPrices);
    const maxPrice = Math.max(...filteredPrices);

    // Check if min and max are equal
    if (minPrice === maxPrice) {
      return `${formatNumber(minPrice)}`; // Return only the minimum price
    }

    return `${formatNumber(minPrice)} - ${formatNumber(maxPrice)}`;
  };




  if (dataStoreInfo?.store === null) {
    router.push("/");
    return null;
  }

  // const [priceRange, setPriceRange] = useState('');

  // useEffect(() => {
  //   setPriceRange(findPriceRange(dataProduct));
  //   setMaxPrice(findPriceMax(dataProduct));
  //   // calDisplayPrice();
  // }, []);

  const formatPrice = (price: number, digits: number = 2): number => {
    // Ensure price is a valid number, otherwise default to 0
    if (isNaN(price)) {
      price = 0;
    }
    
    // Format the price to the specified number of decimal places
    const formattedPrice = parseFloat(price.toFixed(digits));
    return formattedPrice;
  };

  const itemList = {
    itemListId: "related_products",
    itemListName: "สินค้า/บริการ ที่เกี่ยวข้อง",
  };

  const setDataLayer = () => {
    // Guard clause for missing data
    if (!dataProduct?.products) {
      if (!isProduction) console.warn("No product data available.");
      setItems([]);
      return;
    }

    const { products } = dataProduct;
    const {
      product_id,
      product_title,
      product_discounted_price,
      product_normal_price,
      affiliation = null,
      coupon = null,
      item_brand = null,
      item_category = null,
      item_category2 = null,
      item_category3 = null,
      item_category4 = null,
      item_category5 = null,
      location_id = null,
    } = products;

    // Calculate discount and price in a single step
    const isDiscounted = product_discounted_price > 0;
    let price = formatPrice(isDiscounted ? product_discounted_price : product_normal_price);
    let discount = isDiscounted ? formatPrice(product_normal_price - product_discounted_price) : 0;
    let item_variant = null;

    // Handle product options if available
    if (Array.isArray(products?.product_option) && products.product_option.length > 0) {
      const priceOption = products.product_option.flatMap((opt: any) => {
        return (Array.isArray(opt.option_child) && opt.option_child.length > 0)
          ? opt.option_child.map((child: any) => ({
            discount: child.option_discount > 0 ? child.option_price - child.option_discount : 0,
            price: child.option_discount > 0 ? child.option_discount : child.option_price,
            variant: `${opt.option_title} - ${opt.option_name} / ${child.option_title} - ${child.option_name}`,
          }))
          : [{
            discount: opt.option_discount > 0 ? opt.option_price - opt.option_discount : 0,
            price: opt.option_discount > 0 ? opt.option_discount : opt.option_price,
            variant: `${opt.option_title} - ${opt.option_name}`,
          }];
      });

      // Sort priceOption by price in ascending order
      priceOption.sort((a: any, b: any) => a.price - b.price);


      if (priceOption.length > 0) {
        price = formatPrice(priceOption[0].price);
        discount = formatPrice(priceOption[0].discount);
        item_variant = priceOption[0].variant;
      }
    }

    // Create the product item object
    const productItems = {
      item_id: product_id,
      item_name: product_title,
      ...(affiliation && { affiliation }),
      ...(coupon && { coupon }),
      discount,
      index: 0,
      ...(item_brand && { item_brand }),
      ...(item_category && { item_category }),
      ...(item_category2 && { item_category2 }),
      ...(item_category3 && { item_category3 }),
      ...(item_category4 && { item_category4 }),
      ...(item_category5 && { item_category5 }),
      item_list_id: itemList.itemListId,
      item_list_name: itemList.itemListName,
      ...(item_variant && { item_variant }),
      ...(location_id && { location_id }),
      price,
      quantity: 1,
    };

    // Update items state
    setItems([productItems]);

    // Calculate total value (quantity is always 1)
    const totalValue = (price || 0) * 1;

    // Update dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null }); // Clear previous ecommerce data
    window.dataLayer.push({
      event: "view_item",
      ecommerce: {
        currency: "THB",
        value: formatPrice(totalValue),
        items: [productItems],
      },
    });

    // Debugging log (only in non-production environments)
    if (!isProduction) {
      console.log("DataLayer updated:", {
        event: "view_item",
        ecommerce: {
          currency: "THB",
          value: formatPrice(totalValue),
          items: [productItems],
        },
      });
    }
  };

  // json-ld
  // const [jsonLd, setJsonLd] = useState(null);

  const generateJsonLd = () => {
    const images = dataProduct?.products?.product_image?.map(
      (img: { image_url: any }) => img.image_url
    ) || [];

    const today = new Date();
    const validUntilDate = new Date(today.setDate(today.getDate() + 30));
    const priceValidUntilDate = validUntilDate.toISOString().split("T")[0];

    const sellerDetail = {
      "@context": "http://schema.org",
      "@type": "Organization",
      "name": dataStoreInfo?.store?.store_info_multilanguage?.find((info: { lang: string; }) => info.lang === "th")?.store_title || "Unknown Store",
      "url": `https://maaboom.com/store/${dataStoreInfo?.store?.store_slug}?store=${dataStoreInfo?.store?.id}`,
      "image": dataStoreInfo?.store?.store_icon_image || "https://default-image-url.com/default-image.png",
      "aggregateRating": {
        "@type": "AggregateRating",
        "bestRating": 5,
        "worstRating": 1,
        "ratingCount": 0,
        "ratingValue": dataStoreInfo?.store?.store_score || 0
      }
    };

    const offerDetails = (() => {
      if (Array.isArray(dataProduct?.products?.product_option) && dataProduct?.products?.product_option.length > 0) {
        const offerOptionDetails = dataProduct.products.product_option.flatMap(
          (opt: {
            option_child: any[];
            option_title: any;
            option_name: any;
            option_sku: any;
            option_discount: number;
            option_price: any;
            option_stock: number;
          }) => {
            if (Array.isArray(opt.option_child) && opt.option_child.length > 0) {
              return opt.option_child.map((child) => ({
                "@type": "Offer",
                sku: child.option_sku,
                name: `${opt.option_title} - ${opt.option_name} / ${child.option_title} - ${child.option_name}`,
                price: child.option_discount > 0 ? child.option_discount : child.option_price,
                priceCurrency: "THB",
                availability: child.option_stock > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
                priceValidUntil: priceValidUntilDate,
                seller: sellerDetail,
              }));
            } else {
              return {
                "@type": "Offer",
                url: currentUrl,
                sku: opt.option_sku,
                name: `${opt.option_title} - ${opt.option_name}`,
                price: opt.option_discount > 0 ? opt.option_discount : opt.option_price,
                priceCurrency: "THB",
                availability: opt.option_stock > 0 ? "InStock" : "OutOfStock",
                itemCondition: "NewCondition",
                priceValidUntil: priceValidUntilDate,
                seller: sellerDetail,
              };
            }
          }
        );
        // Sort priceOption by price in ascending order
        offerOptionDetails.sort((a: any, b: any) => a.price - b.price);

        return offerOptionDetails.length > 0 ? offerOptionDetails[0] : null;
      } else {
        return {
          "@type": "Offer",
          url: currentUrl,
          priceCurrency: "THB",
          price: dataProduct?.products?.product_discounted_price !== 0
            ? dataProduct?.products?.product_discounted_price
            : dataProduct?.products.product_normal_price,
          itemCondition: "https://schema.org/UsedCondition",
          availability: dataProduct?.products?.product_stock > 0 ? "InStock" : "OutOfStock",
          priceValidUntil: priceValidUntilDate,
          seller: sellerDetail,
        };
      }
    })();

    const ratingValue = Math.min(Math.max(dataProduct?.products?.product_score || 0, 0), 5);
    const reviewCount = Math.max(0 || 0, 1);

    return {
      "@context": "https://schema.org",
      "@type": "Product",
      name: he.decode(dataProduct?.products?.product_title || "").replace(/<[^>]*>/g, ""),
      description: he.decode(dataProduct?.products?.product_detail || "").replace(/<[^>]*>/g, ""),
      url: currentUrl,
      productID: dataProduct?.products?.product_id || null,
      image: images,
      sku: dataProduct?.products?.product_sku || null,
      mpn: dataProduct?.products?.product_sku || null,
      offers: offerDetails,
      aggregateRating: {
        "@type": "AggregateRating",
        "bestRating": 5,
        "worstRating": 1,
        ratingValue: ratingValue,
        reviewCount: reviewCount,
      },
    };
  };

  // useEffect(() => {
  //   setDataLayer();
  //   const jsonLdData = generateJsonLd();
  //   setJsonLd(jsonLdData);
  // }, [dataProduct.products]);

  const getStoreTitleInThai = (storeInfoMultilanguage: any[]) => {
    if (Array.isArray(storeInfoMultilanguage)) {
      const storeTitle = storeInfoMultilanguage.find(
        (dataTil: any) => dataTil.lang === 'th'
      );
      return storeTitle ? storeTitle.store_title : 'Unknown Store';
    }
    return 'Unknown Store';
  };

  const jsonLdBreadcrumbs = [
    {
      // "@type": "ListItem",
      "position": 1,
      "name": "maaboom",
      "item": "https://maaboom.com/"
    },
    {
      // "@type": "ListItem",
      "position": 2,
      "name": getStoreTitleInThai(dataStoreInfo?.store?.store_info_multilanguage),
      "item": `https://maaboom.com/store/${dataStoreInfo?.store?.store_slug}?store=${dataStoreInfo?.store?.id}&limit=${limitMore}`
    },
    {
      // "@type": "ListItem",
      "position": 3,
      "name": dataProduct?.products?.product_title || 'Unknown Product',
      "item": currentUrl
    }
  ];

  const videoSrc = dataProduct?.products?.product_vdo;

  // if (!dataProductSpecific) {
  //   return {
  //     notFound: true,
  //   };
  // }





  return (
    <>
      <NextSeo
        title={dataProduct?.products?.product_title}
        titleTemplate={`%s | ${seoConfig.title}`}
        defaultTitle={seoConfig.defaultTitle}
        description={seoConfig.description}
        canonical={currentUrl}
        openGraph={{
          ...seoConfig.openGraph,
          url: currentUrl,
          title: `${dataProduct?.products?.product_title} | ${seoConfig.title}`,
          images: [
            {
              url: imageShare,
              width: 1200,
              height: 630,
              alt: dataProduct?.products?.product_title,
              type: "image/png",
              secureUrl: imageShare,
            },
          ],
        }}
        additionalMetaTags={[
            ...seoConfig.additionalMetaTags,
            isProduction ? seoConfig.robots.isProduction : seoConfig.robots.isNotProduction,
            {
              name: "twitter:title",
              content: dataProduct?.products?.product_title,
            },
            {
              name: "twitter:description",
              content: dataProduct?.products?.product_title,
            },
            {
              name: "twitter:image",
              content: imageShare,
            },
        ] as MetaTag[]}
        twitter={seoConfig.twitter}
        facebook={seoConfig.facebook}
      />

      {jsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      )}

      <BreadcrumbJsonLd itemListElements={jsonLdBreadcrumbs} />

      {videoSrc ? (
      <VideoJsonLd 
        name={dataProduct?.products?.product_title}
        description={dataProduct?.products?.product_title}
        contentUrl={videoSrc}
        embedUrl={currentUrl.replace('/product/', '/embed/')}
        uploadDate={new Date().toISOString()}
        duration={"PT0M15S"}
        thumbnailUrls={[
          ...dataProduct?.products?.product_image.map((item: { image_url: any; }) => item.image_url),
        ]}
        regionsAllowed={['*']}
      />
      ) : ('')}

      <Box sx={{ width: "100%", my: 0 }}>
        <Grid container xs={12} md={12} lg={12}>
          <Grid lg={12} sx={{ pt: 4, pb: 2 }}>
            <Breadcrumbs maxItems={5} aria-label="breadcrumb">
              <Link color="inherit" href="/">Home</Link>
              <Link
                color="inherit"
                href={{
                  pathname: `/store/${dataStoreInfo?.store?.store_slug}`,
                  query: {
                    store: dataStoreInfo?.store?.id,
                    product_type: "Product" 
                  }
                }}
              >
                {Array.isArray(dataStoreInfo?.store?.store_info_multilanguage) &&
                  dataStoreInfo.store.store_info_multilanguage.map((dataTil: any) => {
                    if (dataTil.lang === "th") {
                      return ReactHtmlParser(dataTil.store_title);
                    }
                    return null;
                  })}
              </Link>
              <Typography color="text.primary">
                {dataProduct?.products?.product_title}
              </Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <ProductDetail
          dataProduct={dataProduct}
          campaign={campaign}
          dataStoreInfo={dataStoreInfo}
          productType={productType}
          dataWaranty={dataWaranty}
          dataProductDetail={dataProductDetail}
          dataProductSpecific={dataProductSpecific}
          getToken={getToken}
          dataCampaigncomingsoon={dataCampaigncomingsoon}
        />

        <StarRatingreview storeId={storeId} type={"product"}
          dataStoreInfo={dataStoreInfo?.store?.store_score}
          ProductIdReview={ProductIdReview}
          dataProduct={dataProduct?.products.product_score}
        >

        </StarRatingreview>

        <Grid container xs={12} md={12} lg={12} sx={{ py: 2 }}>
          <Grid xs={12} md={12} sm={12} xl={12} lg={12} sx={{ my: 1 }}>
            <Grid container sx={{ mb: 2 }}>
              <Typography className="txt-title">
                {productType == "Product" ? 'สินค้า' : productType == "Service" ? 'บริการ' : 'สินค้า'}
                จากร้านเดียวกัน
              </Typography>
            </Grid>
            <ProductUtility dataSet={dataProductSameStore} itemList={itemListRelate} />
          </Grid>

          <Grid xs={12} md={12} sm={12} xl={12} lg={12} sx={{ my: 1 }}>
            <Grid container sx={{ mb: 2 }}>
              <Typography className="txt-title">
                บริการ/สินค้า ที่คุณอาจจะชอบ
              </Typography>
            </Grid>
            <ProductUtility dataSet={dataProductRec} itemList={itemListReccomment} />
          </Grid>
        </Grid>
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          className="fontSize-20 txt-bold"
          sx={{ textAlign: "center", mt: "30px" }}
          id="alert-dialog-title"
        >
          {"รถเข็น"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            sx={{ px: { xs: "20px", md: "50px" } }}
            id="alert-dialog-description"
          >
            กรุณาเลือกตัวเลือกของสินค้าก่อน
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", mb: "30px" }}>
          <Button
            onClick={handleClose}
            autoFocus
            className="btn-4"
            sx={{ padding: "10px 60px", margin: "0 !important" }}
          >
            ตกลง
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openCart}
        onClose={handleCloseCart}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
      >
        <DialogTitle
          className="fontSize-20 txt-bold"
          sx={{ textAlign: "center", mt: "30px" }}
          id="alert-dialog-title"
        >
          {"รถเข็น"}
        </DialogTitle>
        <DialogContent sx={{ textAlign: "center" }}>
          <DialogContentText id="alert-dialog-description">
            เพิ่มสินค้าไปยังรถเข็นของคุณแล้ว
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "center",
            gap: "15px",
            mb: "30px",
          }}
        >
          <Button
            className="btn-cancle"
            onClick={handleCloseCart}
          >
            ซื้อสินค้าต่อ
          </Button>
          <Button
            className="btn-success"
            onClick={handleGoCart}
            autoFocus
          >
            ไปยังรถเข็น
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (
  context: any
) => {
  try {
    const limit = "10";
    const offset = "0";
    const authToken = context.req.cookies.token;
    const getToken = authToken !== "" ? authToken : null;
    const slug = context.params.slug as string;
    const productId = context.query.id as string;
    const storeId = context.query.store as string;

    const [
      resProduct,
      resProductDetail,
      resProductSpecific,
      resProductWaranty,
      resProductReview,
      resStoreInfo,
      getCurrentCampaign,
      getCampaigncomingsoon,
    ] = await Promise.all([
      ApiProduct.ProductInfo(productId),
      ApiProduct.ProductDetail(productId),
      ApiProduct.ProductSpecific(productId),
      ApiProduct.ProductWarranty(productId),
      ApiProduct.ProductReview(productId, limit, offset, authToken),
      ApiStore.StoreInfo(storeId, getToken),
      Campaign.getCurrentCampaign(),
      GetCampaignComingSoon(),
    ]);

    const dataProduct = resProduct?.data || null;
    const dataProductDetail = resProductDetail?.data || null;
    const dataProductSpecific = resProductSpecific?.data?.[0] || null;
    const dataWaranty = resProductWaranty?.data || null;
    const dataReview = resProductReview?.data || null;
    const dataStoreInfo = resStoreInfo?.data || null;
    const campaign = getCurrentCampaign?.data || null;
    const dataCampaignComingSoon = getCampaigncomingsoon?.data || null;

    if (!dataProduct) {
      return {
        notFound: true,
      };
    }

    if (!dataProductSpecific) {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        dataProduct,
        dataProductDetail,
        dataProductSpecific,
        dataWaranty,
        dataReview,
        dataStoreInfo,
        slug,
        campaign,
        dataCampaignComingSoon,
      },
    }

  } catch (error) {
    if (!isProduction) {
      console.error("Error fetching product data:", error);
    }

    return {
      notFound: true,
    };
  }
};
